import type {
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	OverrideContainerComponent,
	StoreActionApi,
} from 'react-sweet-state';
import {
	createStore,
	createStateHook,
	createActionsHook,
	createContainer,
} from 'react-sweet-state';

export const WarningDialog = {
	NAV: 'NAV',
	FLOATING: 'FLOATING',
} as const;

type WarningDialogType = keyof typeof WarningDialog;

type WarningDialogState = {
	isWarningDialogOpen: boolean;
	warningDialog: WarningDialogType;
};
export const initialWarningDialogState: {
	isWarningDialogOpen: boolean;
	warningDialog: 'NAV';
} = {
	isWarningDialogOpen: false,
	warningDialog: WarningDialog.NAV,
};

export const actions = {
	showWarningDialog:
		(warningDialogDisplayType?: WarningDialogType) =>
		({ setState }: StoreActionApi<WarningDialogState>): void => {
			const warningDialog = warningDialogDisplayType || WarningDialog.NAV;
			setState({ isWarningDialogOpen: true, warningDialog });
		},
	hideWarningDialog:
		() =>
		({ setState }: StoreActionApi<WarningDialogState>): void => {
			setState({ isWarningDialogOpen: false, warningDialog: WarningDialog.NAV });
		},
};
type WarningDialogActionType = typeof actions;

const Store = createStore<WarningDialogState, WarningDialogActionType>({
	initialState: initialWarningDialogState,
	actions,
	name: 'WarningDialogState',
});

export const IssueCreateWarningDialogContainer: OverrideContainerComponent<unknown> =
	createContainer(Store);

export const useWarningDialogStateActions: HookActionsFunction<
	BoundActions<
		WarningDialogState,
		{
			showWarningDialog: (
				warningDialogDisplayType?: WarningDialogType,
			) => ({ setState }: StoreActionApi<WarningDialogState>) => void;
			hideWarningDialog: () => ({ setState }: StoreActionApi<WarningDialogState>) => void;
		}
	>
> = createActionsHook(Store);

export const useIsWarningDialogOpen: HookStateFunction<boolean, void> = createStateHook(Store, {
	selector: (state: WarningDialogState) => state.isWarningDialogOpen,
});

export const useGetWarningDialog: HookStateFunction<'NAV' | 'FLOATING', void> = createStateHook(
	Store,
	{
		selector: (state: WarningDialogState) => state.warningDialog,
	},
);
